import { render, staticRenderFns } from "./number.vue?vue&type=template&id=b99bca30&"
import script from "./number.vue?vue&type=script&lang=js&"
export * from "./number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b99bca30')) {
      api.createRecord('b99bca30', component.options)
    } else {
      api.reload('b99bca30', component.options)
    }
    module.hot.accept("./number.vue?vue&type=template&id=b99bca30&", function () {
      api.rerender('b99bca30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/number.vue"
export default component.exports